import { BrowserRouter, Routes, Route } from "react-router-dom";
import AnggotaList from "./components/AnggotaList";

function App() {
  return (
    <div className="container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AnggotaList />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
